
// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: `${process.env.VUE_APP_FIREBASE_API_KEY}`,
  authDomain: `${process.env.VUE_APP_FIREBASE_PROJ_ID}.firebaseapp.com`,
  databaseURL: `https://${process.env.VUE_APP_FIREBASE_PROJ_ID}.firebaseio.com`,
  projectId: `${process.env.VUE_APP_FIREBASE_PROJ_ID}`,
  storageBucket: `${process.env.VUE_APP_FIREBASE_PROJ_ID}.appspot.com`,
  messagingSenderId: `${process.env.VUE_APP_FIREBASE_SENDER_ID}`,
  appId: `${process.env.VUE_APP_FIREBASE_APP_ID}`,
};
// Initialize Firebase
window.firebase.initializeApp(firebaseConfig);

// check firebase connection
const db = window.firebase.database();
const connectedRef = db.ref('.info/connected');
connectedRef.on('value', (snap) => {
  if (snap.val()) {
    // eslint-disable-next-line
    console.log('firebase connected');
  }
  else {
    // eslint-disable-next-line
    console.log('firebase not connected');
  }
});

// export
export const auth = window.firebase.auth();
export const database = db;
export const storage = window.firebase.storage();
